export default "3,Høyereliggende områder og luftingsområder\n4,Lavereliggende sommerland\n"